import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MensajesService} from 'src/app/service/message.service';
import { MensajeVariosContactos } from 'src/app/interfaces/MensajeVariosContactosData';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
import { ListaContactosService } from 'src/app/service/listaContactos.service';
import { ListaContactos } from 'src/app/interfaces/ListaContactosData';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-envio-masivo-mensaje',
  templateUrl: './envio-masivo-mensaje.component.html',
  styleUrls: ['./envio-masivo-mensaje.component.scss'],
  providers: [MessageService]
})
export class EnvioMasivoMensajeComponent implements OnInit{
  deviceUrl: string = '';
  deviceName: string = '';
  camposMensaje: MensajeVariosContactos = {
    idCustomer: 0,
    token: '',
    opcion: '1',
    numeros: [],
    nombreCampania: '',
    mensaje: '',
    verificarNumeros: 'No',
    numerosTexto: '',
    nombreLista: ''
  };

  validar: boolean = false;

  archivoSeleccionado: File | null = null;

  ingresoManualSeleccionado: boolean = true;
  importacionCsvSeleccionada: boolean = false;
  listaSeleccionada: boolean = false; 

  listas: ListaContactos[] = [];

  listaElegida: any;

  soloNumerosValidacion: RegExp = /^[0-9\s]+$/;

  constructor(private formBuilder: FormBuilder, private mensajeService: MensajesService, private messageService: MessageService, 
    private route: ActivatedRoute, private loginService: LoginService, private listasContactosService: ListaContactosService, 
    private router: Router, private translate: TranslateService) {
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
    }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['deviceUrl'] || '';
      const nombre = params['deviceName'] || '';
      if (token) {
        this.deviceUrl = token;
      } 
      if(nombre){
        this.deviceName = nombre;
      }
    });

    if (this.camposMensaje.opcion === '1') {
      this.ingresoManualSeleccionado = true;
    } else if (this.camposMensaje.opcion === '2') {
      this.importacionCsvSeleccionada = true;
    } else if (this.camposMensaje.opcion === '3') {
      this.listaSeleccionada = true;
    }
    this.camposMensaje.idCustomer = this.loginService.chatCrmUser.idCustomer;
    //obter listas de contactos
    this.route.queryParams.subscribe(params => {
      const token = params['deviceUrl'] || '';
      if (token) {
        this.listasContactosService.getAllContactos(token).subscribe((listas: ListaContactos[]) => {
          this.listas = listas;
          console.log(this.listas);
        });
      } 
    });
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  // Método para manejar la selección de archivos
  onFileSelected(event: any) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.archivoSeleccionado = fileList[0];
    }
  }

  enviarMensaje(): void {
    if( this.camposMensaje.nombreCampania === "" || this.camposMensaje.mensaje === ""){
      this.messageService.add({severity: 'error', summary: 'Error', detail: this.translate.instant('ALERT_FIELDS')})
      this.validar = true;
      return;      
    }

    if (!this.deviceUrl) {
      this.messageService.add({
        severity: 'error', 
        summary: 'Error', 
        detail: this.translate.instant('SELECT_DEVICE_ERROR')
      });
      return;
    }
    
     // Limpiar la cadena de números de cualquier espacio en blanco adicional
     this.camposMensaje.numerosTexto = this.camposMensaje?.numerosTexto?.replace(/\s+/g, ',');

     // Remover comas duplicadas, si las hubiera
     this.camposMensaje.numerosTexto = this.camposMensaje?.numerosTexto?.replace(/,{2,}/g, ',');
 
     // Si la cadena comienza con una coma, eliminarla
     this.camposMensaje.numerosTexto = this.camposMensaje?.numerosTexto?.replace(/^,+/g, '');
 
     // Si la cadena termina con una coma, eliminarla
     this.camposMensaje.numerosTexto = this.camposMensaje?.numerosTexto?.replace(/,+$/g, '');
 
     // Actualizar el arreglo de números
     this.camposMensaje.numeros = this.camposMensaje?.numerosTexto?.split(',');

    this.camposMensaje.token = this.deviceUrl;

    if (this.listaSeleccionada) {
      this.camposMensaje.nombreLista = this.listaElegida;
    } 
      if (this.archivoSeleccionado) {
        console.log("Archivo seleccionado:", this.archivoSeleccionado);
        // Llama al servicio para crear la lista, pasando la nuevaLista y el archivoSeleccionado
        this.mensajeService.enviarMensajeMuchosContactos(this.camposMensaje, this.archivoSeleccionado)
        .subscribe((response) => {
            this.messageService.add({ severity: 'success', summary: 'Éxito', detail: this.translate.instant('MESSAGE_SUCCES')});
            setTimeout(()=>{this.router.navigate(['/campaigns'], {queryParams: {deviceUrl: this.deviceUrl, deviceName: this.deviceName},
            queryParamsHandling: 'merge'})},2500)
          }, (error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_ERROR')});
          });
      } else {
        // Llama al servicio para crear la lista solo con los datos de la nuevaLista
        this.mensajeService.enviarMensajeMuchosContactos(this.camposMensaje, null)
          .subscribe(() => {
            this.messageService.add({ severity: 'success', summary: 'Éxito', detail: this.translate.instant('MESSAGE_SUCCES')});
            setTimeout(()=>{this.router.navigate(['/campaigns'], {queryParams: {deviceUrl: this.deviceUrl, deviceName: this.deviceName},
            queryParamsHandling: 'merge'})},2500)
          }, (error) => {
            this.messageService.add({severity: 'error', summary: 'Error', detail: this.translate.instant('MESSAGE_ERROR')})
          });
      }    
  }

  cambiarOpcion(opcionSeleccionada: string, event: any) {
    if (event.target.checked) {
      this.camposMensaje.opcion = opcionSeleccionada;
      if(this.camposMensaje.opcion === '1'){
        this.importacionCsvSeleccionada = false; 
        this.listaSeleccionada = false;
        this.ingresoManualSeleccionado = true;
      } else if (this.camposMensaje.opcion === '2') {
        this.importacionCsvSeleccionada = true; 
        this.listaSeleccionada = false; 
        this.ingresoManualSeleccionado = false;
      } else if (this.camposMensaje.opcion === '3') {
        this.listaSeleccionada = true;
        this.importacionCsvSeleccionada = false;
        this.ingresoManualSeleccionado = false; 
      }
  } else {
    this.camposMensaje.opcion = '';
  }
  }

  seleccionarLista(event: any){
    const selectedId = event.target.value; // Obtener el ID seleccionado del evento
    const selectedList = this.listas.find(lista => lista.id === selectedId); // Buscar el objeto en listas con el ID seleccionado
    if (selectedList) {
        this.listaElegida = selectedList.nombre; // Asignar el nombre de la lista seleccionada a listaElegida
    } else {
        this.listaElegida = ''; // Si no se encuentra ninguna lista con ese ID, se asigna una cadena vacía
    }
    console.log(this.listaElegida);
}

regresar(deviceUrl: string, deviceName: string){
  this.router.navigate(['/campaigns'], { queryParams: { deviceUrl: this.deviceUrl, deviceName: this.deviceName },
  queryParamsHandling: 'merge' });
}

verificarSoloNumeros(texto: string): boolean {
  return this.soloNumerosValidacion.test(texto);
}

}
